var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InvoiceRow',_vm._l((_vm.fields),function(field){return _c('v-th',{key:field},[_vm._v("\n    "+_vm._s(field)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }